import { observer } from 'mobx-react';
import { Banner } from '.';
import { Flex, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import telegram from '../../assets/icons/telegram-icon.svg';

const telegramBlue = '#24A1DE';

export const TelegramChannelBanner = observer(
  ({
    maxWidth = '1100px',
    minWidth = '380px',
    padding = '0px 20px 10px 20px',
  }: {
    maxWidth?: string;
    minWidth?: string;
    padding?: string;
  }) => {
    const { t } = useTranslation('banner');

    return (
      <Banner
        padding={padding}
        maxWidth={maxWidth}
        minWidth={minWidth}
        color={telegramBlue}
      >
        <div
          style={{
            display: 'flex',
            gap: '5px',
            flexWrap: 'wrap',
          }}
        >
          <Text fw={600}>{t('telegram.title')}</Text>
          <Flex gap={10}>
            <Text>{t('telegram.joinPrompt')}:</Text>
            <Link to={'https://t.me/scr_swiss'} target={'_blank'}>
              <img
                height={'20px'}
                width={'20px'}
                src={telegram}
                alt="Telegram icon"
                style={{ color: '#fff' }}
              />
            </Link>
          </Flex>
        </div>
        <Text>{t('telegram.text1')}</Text>
      </Banner>
    );
  },
);
